import { Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";

const SortBy = (props) => {
    const [sortByVal,setSortByVal] =useState('Most Recent');
    const [sortByEl, setsortByEl] = useState(null);
    const dropdownopen = Boolean(sortByEl);
    const handleDropdownClick = (event) => {
        setsortByEl(event.currentTarget);
    };
    const handleDropdownChange = (ans) => {
        props.handleSortBy(ans);
        setSortByVal(ans);
        setsortByEl(null);
    };

    //console.log('sortByVal', sortByVal)
  return (
        <div className={`select_opt relative bottom-[2px] pl-[20px] right-[20px] cursor-pointer shrink-0`}>
            <img src="/images/select_icon2.svg" alt="arrow" className="absolute top-[11px] left-[22px]" />
            <img src="/images/select_icon1.svg" alt="arrow" className="absolute top-[15px] right-[2px]" />
            <Button
                id="sortby-button"
                aria-controls={dropdownopen ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={dropdownopen ? 'true' : undefined}
                onClick={handleDropdownClick}
            >
                {sortByVal}
            </Button>
            <Menu
                id="sortby-menu"
                anchorEl={sortByEl}
                open={dropdownopen}
                onClose={()=>setsortByEl(null)}
                MenuListProps={{
                'aria-labelledby': 'basic-button',
                }}
            >
                {
                    ['Most Recent','Loan Amount Asc','Loan Amount Dsc'].map((item,idx)=>{
                        return(
                            <MenuItem key={idx} onClick={()=>handleDropdownChange(item)}>{item}</MenuItem>
                        )
                    })
                }
            </Menu>
        </div>
  )
};

export default SortBy;
